import React, { useState, useEffect } from 'react'
import { Button, Modal, Table } from 'react-bootstrap'
import { Auth } from 'aws-amplify'
import { Link } from 'react-router-dom'
class DuplicateContentForm extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			contentDetails: {},
			isNewLang: false,
			contentID: '',
			langModalVisible: false,
			contentLanguageOptions: [
				{
					label: 'English',
					value: 'En',
					id: 0,
				},
				{
					label: 'Telugu',
					value: 'Te',
					id: 1,
				},
			],
			contentSelectedLangVal: this.props.item.contentLanguage == 'English' ? 'Te' : "En",
			editContent: false,
		}
	}
	changeContentLanguage = (lang) => {

		this.setState({ contentSelectedLangVal: lang })
	}
	openModal = async () => {
		this.setState({ langModalVisible: true })
	}

	closeModal = () => {
		this.setState({
			langModalVisible: false,
			contentSelectedLangVal: this.props.item.contentLanguage == 'English' ? 'Te' : "En"
		})
	}

	renderLanguageModal = () => {
		const { langModalVisible, contentLanguageOptions, contentSelectedLangVal } = this.state
		const PK = this.props.item.PK.replace('cont#', '')

		return (
			<Modal show={langModalVisible} onHide={() => this.closeModal()}>
				<Modal.Body>
					<div className='row'>
						<label>Choose Language </label>
						{contentLanguageOptions.map((language) => (
							<div>
								<input
									value={contentSelectedLangVal}
									type='radio'
									checked={contentSelectedLangVal == language.value}
									onClick={() => {
										this.changeContentLanguage(language.value)
									}}
								></input>
								<text for={language.label}>{language.label}</text>
							</div>
						))}
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={() => this.closeModal()}>Cancel</Button>
					<Link class='col-md-4 ' to={`/duplicateContent?${PK}?${this.state.contentSelectedLangVal}`} target='_blank'>
						<Button disabled={!this.state.contentSelectedLangVal} onClick={() => this.setState({ langModalVisible: false })}>Ok</Button>
					</Link>
				</Modal.Footer>
			</Modal>
		)
	}

	render() {
		return (
			<>
				<div
					data-toggle='tooltip'
					title={`Duplicate Content`}
					style={{ fontSize: '12px' }}
					class={'col-md-3 faIconClass'}
					onClick={() => {
						this.openModal()
					}}
				>
					<i class='fas fa-clone fa-lg' />
				</div>

				{this.renderLanguageModal()}
			</>

		)
	}
}

export default DuplicateContentForm
